import React from 'react';
import { List } from 'react-virtualized';
import cn from 'classnames';
import { Select } from 'components/UI';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { sendError } from 'redux_store/modules/log';
import { trashImg, eyeImg as EyeImg } from 'theme/icon';
import { subscribeCreate, subscribeRemove } from 'redux_store/modules/tenderCard';

import styles from './styles.scss';

@connect(null, { subscribeCreate, subscribeRemove, sendError })
class TenderSubscribePopup extends React.PureComponent {
  static propTypes = {
    tenderId: PropTypes.number.isRequired,
    subscribeCreate: PropTypes.func.isRequired,
    sendError: PropTypes.func.isRequired,
    subscribeRemove: PropTypes.func.isRequired,
    subscribe: PropTypes.arrayOf(PropTypes.object).isRequired,
    other: PropTypes.arrayOf(PropTypes.object).isRequired,
  };

  constructor(props) {
    super(props);
    this.rowRenderer = this.rowRenderer.bind(this);
    this.optionRenderer = this.optionRenderer.bind(this);
  }

  // eslint-disable-next-line react/sort-comp
  rowRenderer({ key, index, style }) {
    const { id, photo, name, isAccess } = this.props.subscribe[index];
    const customStyle = style;

    return (
      <div key={key} style={customStyle} className={styles.subscribePopupRow}>
        <div className={styles.user}>
          <div className={styles.photo}>
            <img alt="" src={photo} />
          </div>

          <div className={styles.name}>{name}</div>
          {!isAccess && <EyeImg alt="" />}
        </div>

        <div className={styles.trash} onClick={() => this.props.subscribeRemove(this.props.tenderId, id)}>
          <img alt="" src={trashImg} />
        </div>
      </div>
    );
  }

  optionRenderer = ({ style: styleOption, option, selectValue }) => {
    const { name, photo } = option;
    return (
      <div
        style={styleOption}
        className={cn('VirtualizedSelectOption', styles.popupOptionRender)}
        onClick={() => selectValue(option)}
      >
        <div className={styles.photo}>
          <img alt="" src={photo} />
        </div>
        <div className={styles.name}>{name}</div>
      </div>
    );
  };

  render() {
    const { subscribe, other, tenderId } = this.props;

    return (
      <div className={styles.dropdown}>
        <div className={styles.header}>
          <div className={styles.caption}>Добавить подписчиков</div>
          <Select
            optionRenderer={this.optionRenderer}
            placeholder="Поиск"
            // multi
            options={other}
            labelKey="name"
            valueKey="id"
            style={{ width: 318, margin: '3px 0px' }}
            autoFocus={false}
            onChange={async e => {
              try {
                await this.props.subscribeCreate(tenderId, e);
              } catch (err) {
                this.props.sendError({ errorText: err.message });
              }
            }}
          />
          <div className={styles.caption}>Начните ввод для пользователей</div>
        </div>
        <List width={338} height={135} rowCount={subscribe.length} rowHeight={32} rowRenderer={this.rowRenderer} />
      </div>
    );
  }
}

export default TenderSubscribePopup;
